export default {
  name: 'BillsNotifyPreview',
  data () {
    return {
      items: [],
      removedIds: [],
      loading: false,
      sending: false
    }
  },
  computed: {
    visibleItems () {
      return this.items.filter(el => !el.skipReason);
    },
    skippedItems () {
      return this.items.filter(el => el.skipReason);
    },
    includedItems () {
      return this.visibleItems.filter(el => !this.removedIds.includes(el.id));
    },
    totalBillCount () {
      return this.includedItems.reduce((total, el) => total + parseInt(el.billCount || 0), 0);
    },
    totalUnpaid () {
      return this.includedItems.reduce((total, el) => total + parseFloat(el.remainingBalance || 0), 0);
    },
    tableHeaders () {
      return [
        { key: 'name', label: this.$t('client.name') },
        { key: 'email', label: this.$t('bill.receiver_emails') },
        { key: 'billCount', label: this.$t('bill.count') },
        { key: 'remainingBalance', label: this.$t('bill.remainingBalance'), format: 'formatDecimal', precision: 2 },
        { key: 'remove', label: '', type: 'slot', slotcode: 'remove' }
      ];
    },
    billHeaders () {
      return [
        { key: 'bill_number', label: this.$t('bill.number') },
        { key: 'invoiceDate', label: this.$t('bill.invoiceDate'), type: 'date' },
        { key: 'remainingBalance', label: this.$t('bill.remainingBalance'), format: 'formatDecimal', precision: 2 }
      ];
    }
  },
  methods: {
    show (clientIds) {
      this.items = [];
      this.removedIds = [];
      this.loading = true;
      this.$refs['modal-window'].show();
      const self = this;
      this.ApiRequest.request('client-bill/unpaid/notify-preview', this.ApiRequest.REQUEST_POST, { clients: clientIds }, function (response) {
        if (response.data) {
          self.items = response.data;
        }
        self.loading = false;
      })
    },
    close () {
      this.$refs['modal-window'].hide();
    },
    removeItem (item) {
      this.removedIds.push(item.id);
    },
    send () {
      if (this.includedItems.length === 0 || this.sending) {
        return;
      }
      this.sending = true;
      const clientIds = this.includedItems.map(el => el.id);
      const self = this;
      this.ApiRequest.request('client-bill/unpaid/notify', this.ApiRequest.REQUEST_POST, { clients: clientIds }, function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
        } else {
          self.$emit('saved', response.data);
          self.close();
        }
        self.sending = false;
      })
    }
  }
}
